/* theme.js — Homestar Shopify Theme (overlay-header v2) */
'use strict';

(function () {

  /* ── Marketing signup config (SMS welcome copy, account links) ── */
  function readMarketingConfig() {
    var el = document.getElementById('HomestarMarketingConfig');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function buildWelcomeMessage(template, vars) {
    if (!template) return '';
    return template
      .replace(/\{\{\s*discount_code\s*\}\}/gi, vars.discountCode || '')
      .replace(/\{\{\s*shop_name\s*\}\}/gi, vars.shopName || '')
      .replace(/\{\{\s*shop_url\s*\}\}/gi, vars.shopUrl || '')
      .replace(/\{\{\s*set_password_url\s*\}\}/gi, vars.setPasswordUrl || '')
      .replace(/\{\{\s*account_url\s*\}\}/gi, vars.accountLoginUrl || vars.setPasswordUrl || '');
  }

  var marketingConfig = readMarketingConfig();
  window.HomestarMarketing = {
    config: marketingConfig,
    buildWelcomeMessage: function (extra) {
      if (!marketingConfig) return '';
      return buildWelcomeMessage(marketingConfig.welcomeMessageTemplate, {
        discountCode: (extra && extra.discountCode) || marketingConfig.discountCode,
        shopName: marketingConfig.shopName,
        shopUrl: marketingConfig.shopUrl,
        setPasswordUrl: marketingConfig.setPasswordUrl,
        accountLoginUrl: marketingConfig.accountLoginUrl
      });
    }
  };

  /* ── Announcement bar body class + message rotation ── */
  if (document.querySelector('.cc-announcement')) {
    document.body.classList.add('has-announcement');
  }

  var announcementBar = document.getElementById('ccAnnouncementBar');
  if (announcementBar && announcementBar.classList.contains('cc-announcement--rotate')) {
    var msgs = announcementBar.querySelectorAll('.cc-announcement__msg');
    if (msgs.length > 1) {
      var activeIdx = 0;
      var rotateMs = parseInt(announcementBar.dataset.rotateMs, 10) || 10000;

      window.setInterval(function () {
        msgs[activeIdx].classList.remove('is-active');
        activeIdx = (activeIdx + 1) % msgs.length;
        msgs[activeIdx].classList.add('is-active');
        announcementBar.setAttribute('aria-label', msgs[activeIdx].textContent.trim());
      }, rotateMs);
    }
  }

  /* ── Header scroll + homepage hero overlay fade ── */
  function initHeaderScroll() {
    var header = document.getElementById('ccHeader');
    if (!header) return;

    var overlayMode = document.body.classList.contains('template-index');
    if (overlayMode) {
      document.body.classList.add('has-hero-overlay');
      header.classList.add('cc-header--overlay-capable');
    }

    var fadeDistance = 120;
    var ticking = false;

    function updateHeaderScroll() {
      ticking = false;
      var scrollY = window.scrollY;

      if (overlayMode) {
        var progress = Math.min(Math.max(scrollY / fadeDistance, 0), 1);
        header.style.setProperty('--header-overlay-progress', progress);
        header.classList.toggle('is-solid', progress >= 0.98);
        header.classList.toggle('scrolled', scrollY > 15 || progress >= 0.15);
      } else {
        header.classList.toggle('scrolled', scrollY > 10);
      }
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateHeaderScroll);
      }
    }

    updateHeaderScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateHeaderScroll, { passive: true });
    window.addEventListener('pageshow', updateHeaderScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderScroll);
  } else {
    initHeaderScroll();
  }

  /* ── Nav drawer toggle ── */
  var menuToggle = document.getElementById('ccMenuToggle');
  var navDrawer = document.getElementById('ccNavDrawer');
  var drawerOpen = false;
  var drawerLastFocus = null;

  function openNavDrawer() {
    if (!navDrawer) return;
    drawerOpen = true;
    drawerLastFocus = document.activeElement;
    navDrawer.hidden = false;
    navDrawer.setAttribute('aria-hidden', 'false');
    navDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    var closeBtn = navDrawer.querySelector('.cc-nav-drawer__close');
    if (closeBtn) closeBtn.focus();
    if (menuToggle) {
      var spans = menuToggle.querySelectorAll('span');
      spans[0].style.transform = 'translateY(6.5px) rotate(45deg)';
      spans[1].style.opacity = '0';
      spans[2].style.transform = 'translateY(-6.5px) rotate(-45deg)';
    }
  }

  function closeNavDrawer() {
    if (!navDrawer) return;
    drawerOpen = false;
    navDrawer.classList.remove('is-open');
    navDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    window.setTimeout(function () {
      if (!drawerOpen) navDrawer.hidden = true;
    }, 320);
    if (menuToggle) {
      var spans = menuToggle.querySelectorAll('span');
      spans[0].style.transform = '';
      spans[1].style.opacity = '';
      spans[2].style.transform = '';
      menuToggle.focus();
    } else if (drawerLastFocus && drawerLastFocus.focus) {
      drawerLastFocus.focus();
    }
  }

  function toggleNavDrawer() {
    if (drawerOpen) closeNavDrawer();
    else openNavDrawer();
  }

  if (menuToggle && navDrawer) {
    menuToggle.addEventListener('click', toggleNavDrawer);
    navDrawer.querySelectorAll('[data-nav-close]').forEach(function (el) {
      el.addEventListener('click', closeNavDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawerOpen) closeNavDrawer();
    });
    navDrawer.querySelectorAll('.cc-nav-drawer__link').forEach(function (link) {
      link.addEventListener('click', closeNavDrawer);
    });
    window.addEventListener('scroll', function () {
      if (!window.matchMedia('(min-width: 769px)').matches) return;
      var header = document.getElementById('ccHeader');
      if (header && header.classList.contains('cc-header--overlay-capable') && header.classList.contains('is-solid') && drawerOpen) {
        closeNavDrawer();
      }
    }, { passive: true });
  }

  /* ── Expandable header search (solid / scrolled header) ── */
  var searchExpand = document.getElementById('ccHeaderSearchExpand');
  var searchExpandToggle = document.getElementById('ccSearchExpandToggle');
  var searchExpandPanel = document.getElementById('ccHeaderSearchPanel');
  var searchExpandOpen = false;

  function closeSearchExpand() {
    if (!searchExpand || !searchExpandOpen) return;
    searchExpandOpen = false;
    searchExpand.classList.remove('is-open');
    if (searchExpandPanel) searchExpandPanel.hidden = true;
    if (searchExpandToggle) searchExpandToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('cc-search-open');
  }

  function openSearchExpand() {
    if (!searchExpand) return;
    searchExpandOpen = true;
    searchExpand.classList.add('is-open');
    if (searchExpandPanel) searchExpandPanel.hidden = false;
    if (searchExpandToggle) searchExpandToggle.setAttribute('aria-expanded', 'true');
    if (window.matchMedia('(max-width: 768px)').matches) {
      document.body.classList.add('cc-search-open');
    }
    var input = searchExpandPanel && searchExpandPanel.querySelector('.cc-header-search__input');
    if (input) window.setTimeout(function () { input.focus(); }, 80);
  }

  if (searchExpandToggle) {
    searchExpandToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (searchExpandOpen) closeSearchExpand();
      else openSearchExpand();
    });
  }

  if (searchExpand) {
    searchExpand.querySelectorAll('[data-search-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeSearchExpand();
      });
    });
  }

  document.addEventListener('click', function (e) {
    if (!searchExpandOpen || !searchExpand) return;
    if (!searchExpand.contains(e.target)) closeSearchExpand();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchExpandOpen) closeSearchExpand();
  });

  var headerForSearch = document.getElementById('ccHeader');
  if (headerForSearch && headerForSearch.classList.contains('cc-header--overlay-capable')) {
    window.addEventListener('scroll', function () {
      if (!headerForSearch.classList.contains('is-solid')) closeSearchExpand();
    }, { passive: true });
  }

  /* ── Product variant selection ── */
  var addToCart = document.getElementById('ccAddToCart');
  var variantsEl = document.getElementById('ccProductVariants');
  var picker = document.getElementById('ccVariantPicker');

  if (variantsEl && picker && addToCart) {
    var variants = JSON.parse(variantsEl.textContent);
    var selected = {};

    function optionValue(variant, position) {
      if (position === 1) return variant.option1;
      if (position === 2) return variant.option2;
      return variant.option3;
    }

    function findVariant() {
      return variants.find(function (v) {
        var match = true;
        [1, 2, 3].forEach(function (pos) {
          if (selected[pos] && optionValue(v, pos) !== selected[pos]) match = false;
        });
        return match;
      });
    }

    function variantExists(position, value) {
      var probe = Object.assign({}, selected);
      probe[position] = value;
      return variants.some(function (v) {
        var match = true;
        [1, 2, 3].forEach(function (pos) {
          if (probe[pos] && optionValue(v, pos) !== probe[pos]) match = false;
        });
        return match;
      });
    }

    function variantAvailable(position, value) {
      var probe = Object.assign({}, selected);
      probe[position] = value;
      return variants.some(function (v) {
        var match = true;
        [1, 2, 3].forEach(function (pos) {
          if (probe[pos] && optionValue(v, pos) !== probe[pos]) match = false;
        });
        return match && v.available;
      });
    }

    function isColorOption(name) {
      var n = (name || '').toLowerCase();
      return n === 'color' || n === 'colour' || n.indexOf('color') !== -1;
    }

    function showVariantGalleryImage(variant) {
      if (!variant || !variant.featured_image) return;
      document.dispatchEvent(new CustomEvent('homestar:gallery-show-image', {
        detail: {
          imageId: variant.featured_image.id,
          src: variant.featured_image.src
        }
      }));
    }

    function findVariantForColor(position, value) {
      var probe = Object.assign({}, selected);
      probe[position] = value;

      var matches = variants.filter(function (v) {
        if (!v.featured_image) return false;
        if (optionValue(v, position) !== value) return false;
        var match = true;
        [1, 2, 3].forEach(function (pos) {
          if (probe[pos] && optionValue(v, pos) !== probe[pos]) match = false;
        });
        return match;
      });

      if (matches.length) {
        return matches.find(function (v) { return v.available; }) || matches[0];
      }

      return variants.find(function (v) {
        return optionValue(v, position) === value && v.featured_image;
      });
    }

    function updatePickerUI() {
      picker.querySelectorAll('.cc-size-option').forEach(function (btn) {
        var pos = parseInt(btn.dataset.optionPosition, 10);
        var val = btn.dataset.value;
        var exists = variantExists(pos, val);
        var available = variantAvailable(pos, val);
        var isSelected = selected[pos] === val;

        btn.classList.toggle('selected', isSelected);
        btn.classList.toggle('sold-out', exists && !available);
        btn.disabled = !exists || !available;
        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      var variant = findVariant();
      if (variant && variant.available) {
        addToCart.dataset.variantId = variant.id;
        addToCart.disabled = false;
        addToCart.textContent = 'Add to Cart';
      } else {
        addToCart.removeAttribute('data-variant-id');
        addToCart.disabled = true;
        addToCart.textContent = variant && !variant.available ? 'Sold Out' : 'Add to Cart';
      }

      updateProductPrice(variant);
      updateLowStock(variant);
    }

    function formatMoney(cents) {
      var amount = (Number(cents) || 0) / 100;
      try {
        return amount.toLocaleString(undefined, {
          style: 'currency',
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
        });
      } catch (e) {
        return '$' + amount.toFixed(2);
      }
    }

    function updateProductPrice(variant) {
      var wrap = document.getElementById('ccProductPriceWrap');
      if (!wrap || !variant) return;
      var price = variant.price;
      var compare = variant.compare_at_price;
      if (compare && compare > price) {
        wrap.innerHTML = '<span class="cc-product-price-sale" data-price-sale>' + formatMoney(price) +
          '</span><span class="cc-product-price-compare" data-price-compare>' + formatMoney(compare) + '</span>';
      } else {
        wrap.innerHTML = '<span data-price-regular>' + formatMoney(price) + '</span>';
      }
    }

    function updateLowStock(variant) {
      var el = document.getElementById('ccLowStock');
      if (!el) return;
      var threshold = parseInt(el.dataset.threshold, 10);
      if (!threshold || threshold <= 0) {
        el.hidden = true;
        return;
      }
      var qty = variant && typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : null;
      var tracked = variant && variant.inventory_management;
      if (tracked && qty !== null && qty > 0 && qty <= threshold) {
        el.textContent = 'Only ' + qty + ' left';
        el.hidden = false;
      } else {
        el.hidden = true;
        el.textContent = '';
      }
    }

    picker.querySelectorAll('.cc-size-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var position = parseInt(btn.dataset.optionPosition, 10);
        var group = btn.closest('.cc-variant-group');
        var optionName = group && group.dataset.optionName;

        selected[position] = btn.dataset.value;
        updatePickerUI();

        if (isColorOption(optionName)) {
          showVariantGalleryImage(findVariantForColor(position, btn.dataset.value));
        }
      });
    });

    var initialVariant = null;
    var params = new URLSearchParams(window.location.search);
    var variantParam = params.get('variant');
    if (variantParam) {
      initialVariant = variants.find(function (v) { return String(v.id) === variantParam; });
    }
    if (!initialVariant) {
      initialVariant = variants.find(function (v) { return v.available; }) || variants[0];
    }
    if (initialVariant) {
      if (initialVariant.option1) selected[1] = initialVariant.option1;
      if (initialVariant.option2) selected[2] = initialVariant.option2;
      if (initialVariant.option3) selected[3] = initialVariant.option3;
    }
    updatePickerUI();
    if (initialVariant && initialVariant.featured_image) {
      showVariantGalleryImage(initialVariant);
    }
  }

  /* ── Size guide modal ── */
  var sizeGuide = document.getElementById('ccSizeGuide');
  if (sizeGuide) {
    function openSizeGuide() {
      sizeGuide.hidden = false;
      sizeGuide.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeSizeGuide() {
      sizeGuide.hidden = true;
      sizeGuide.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    document.querySelectorAll('[data-size-guide-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openSizeGuide();
      });
    });
    sizeGuide.querySelectorAll('[data-size-guide-close]').forEach(function (el) {
      el.addEventListener('click', closeSizeGuide);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sizeGuide.hidden) closeSizeGuide();
    });
  }

  /* ── Add to cart (product page) ── */
  if (addToCart) {
    addToCart.addEventListener('click', function () {
      var variantId = addToCart.dataset.variantId;
      if (!variantId) return;

      var original = addToCart.textContent;
      addToCart.textContent = '...';
      addToCart.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        addToCart.textContent = '✓ Added';
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        if (isDesktopCartDrawer()) openCartDrawer();
        setTimeout(function () {
          addToCart.textContent = original;
          addToCart.disabled = false;
        }, 1800);
      })
      .catch(function () {
        addToCart.textContent = 'Error — Try Again';
        addToCart.disabled = false;
      });
    });
  }

  /* ── Cart drawer (desktop) ── */
  var cartDrawer = document.getElementById('ccCartDrawer');
  var cartToggle = document.getElementById('ccCartToggle');
  var cartDrawerBody = document.getElementById('ccCartDrawerBody');
  var cartDrawerOpen = false;
  var cartDrawerLastFocus = null;
  var desktopCartQuery = window.matchMedia('(min-width: 769px)');

  function isDesktopCartDrawer() {
    return desktopCartQuery.matches && cartDrawer;
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    if (drawerOpen) closeNavDrawer();
    cartDrawerOpen = true;
    cartDrawerLastFocus = document.activeElement;
    cartDrawer.hidden = false;
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
    var closeBtn = cartDrawer.querySelector('.cc-cart-drawer__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawerOpen = false;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    window.setTimeout(function () {
      if (!cartDrawerOpen) cartDrawer.hidden = true;
    }, 320);
    if (cartDrawerLastFocus && cartDrawerLastFocus.focus) {
      cartDrawerLastFocus.focus();
    }
  }

  function refreshCartDrawer() {
    if (!cartDrawerBody) return Promise.resolve();
    return fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data['cart-drawer']) {
          cartDrawerBody.innerHTML = data['cart-drawer'];
        }
      })
      .catch(function (err) { console.error('Cart refresh error:', err); });
  }

  if (cartToggle) {
    cartToggle.addEventListener('click', function (e) {
      if (!isDesktopCartDrawer()) return;
      e.preventDefault();
      if (cartDrawerOpen) closeCartDrawer();
      else openCartDrawer();
    });
  }

  if (cartDrawer) {
    cartDrawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', closeCartDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawerOpen) closeCartDrawer();
    });
  }

  function formatCartMoney(cents) {
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
    });
  }

  function updateCartCounts(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  function updateCartLine(line, qty) {
    var row = document.querySelector('.cc-cart-item[data-line="' + line + '"]');
    if (row) row.classList.add('is-updating');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      updateCartCounts(cart);

      if (qty === 0 || !cart.items.length) {
        updateCartCounts(cart);
        if (cartDrawerOpen) {
          refreshCartDrawer();
        } else if (document.querySelector('.cc-cart-layout')) {
          window.location.reload();
        }
        return;
      }

      var item = cart.items[parseInt(line, 10) - 1];
      if (item) {
        document.querySelectorAll('[data-line-price="' + line + '"]').forEach(function (priceEl) {
          priceEl.textContent = formatCartMoney(item.final_line_price);
        });
        document.querySelectorAll('.cc-qty-input[data-line="' + line + '"]').forEach(function (input) {
          input.value = item.quantity;
        });
      }

      document.querySelectorAll('[data-cart-total]').forEach(function (totalEl) {
        totalEl.textContent = formatCartMoney(cart.total_price);
      });
      if (row) row.classList.remove('is-updating');
    })
    .catch(function (err) {
      console.error('Cart update error:', err);
      if (row) row.classList.remove('is-updating');
    });
  }

  function swapCartVariant(line, qty, variantId) {
    var row = document.querySelector('.cc-cart-item[data-line="' + line + '"]');
    if (row) row.classList.add('is-updating');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: 0 })
    })
    .then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: parseInt(qty, 10) })
      });
    })
    .then(function () {
      if (cartDrawerOpen) return refreshCartDrawer();
      window.location.reload();
    })
    .catch(function (err) { console.error('Cart variant swap error:', err); });
  }

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('.cc-cart-item-remove');
    if (removeBtn) {
      var removeLine = removeBtn.dataset.line;
      if (!removeLine) return;
      updateCartLine(removeLine, 0);
      return;
    }

    var qtyBtn = e.target.closest('.cc-qty-btn');
    if (qtyBtn) {
      var line = qtyBtn.dataset.line;
      var delta = parseInt(qtyBtn.dataset.delta, 10);
      var input = qtyBtn.parentElement.querySelector('.cc-qty-input');
      if (!input) return;
      var newQty = Math.max(0, parseInt(input.value, 10) + delta);
      input.value = newQty;
      updateCartLine(line, newQty);
      return;
    }

    var sizeBtn = e.target.closest('.cc-cart-size-option');
    if (sizeBtn) {
      if (sizeBtn.classList.contains('selected') || sizeBtn.disabled) return;
      var sizeLine = sizeBtn.dataset.line;
      var sizeQty = sizeBtn.dataset.qty;
      var variantId = sizeBtn.dataset.variantId;
      if (!sizeLine || !variantId) return;
      sizeBtn.disabled = true;
      swapCartVariant(sizeLine, sizeQty, variantId);
    }
  });

  /* ── Footer Shopify Email signup (native form + captcha) ── */
  var footerForm = document.getElementById('ccFooterSignupForm');
  var footerEmail = document.getElementById('ccFooterEmail');
  var footerMsg = document.getElementById('ccFooterSignupMsg');
  var footerMsgText = document.getElementById('ccFooterSignupMsgText');
  var footerAccountLink = document.getElementById('ccFooterSignupAccountLink');
  var footerWrap = footerForm && footerForm.closest('.cc-footer__signup');
  var footerDiscountCode = (footerWrap && footerWrap.dataset.discountCode)
    || (footerForm && footerForm.dataset.discountCode)
    || (marketingConfig && marketingConfig.discountCode)
    || 'HOMESTAR10';

  function showFooterSuccess() {
    if (!footerMsg) return;
    footerMsg.hidden = false;
    footerMsg.className = 'cc-footer__signup-msg is-success';
    var successCopy = (marketingConfig && marketingConfig.footerSuccess && marketingConfig.footerSuccess.message)
      || 'Thanks for signing up! Your discount code is ready.';
    if (footerMsgText) {
      footerMsgText.textContent = successCopy + ' Your code: ' + footerDiscountCode + '.';
    }
    if (footerAccountLink && marketingConfig && marketingConfig.setPasswordUrl) {
      footerAccountLink.href = marketingConfig.setPasswordUrl;
      footerAccountLink.textContent = (marketingConfig.footerSuccess && marketingConfig.footerSuccess.accountCta) || 'Set your password';
      footerAccountLink.hidden = false;
    }
    try {
      footerMsg.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (err) { /* ignore */ }
  }

  if (footerForm && footerEmail) {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('customer_posted') === 'true' || params.get('contact_posted') === 'true') {
        showFooterSuccess();
      }
    } catch (err) { /* ignore */ }

    footerForm.addEventListener('submit', function (e) {
      var email = (footerEmail.value || '').trim();
      var valid = window.HomestarMarketing && typeof window.HomestarMarketing.isValidEmail === 'function'
        ? window.HomestarMarketing.isValidEmail(email)
        : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      if (!valid) {
        e.preventDefault();
        if (footerMsg) {
          footerMsg.hidden = false;
          footerMsg.className = 'cc-footer__signup-msg is-error';
          if (footerMsgText) footerMsgText.textContent = 'Enter a valid email address.';
          if (footerAccountLink) footerAccountLink.hidden = true;
        }
        footerEmail.focus();
        return;
      }

      var returnInput = footerForm.querySelector('input[name="return_to"]');
      if (!returnInput) {
        returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        footerForm.appendChild(returnInput);
      }
      returnInput.value = window.location.pathname + '?customer_posted=true#ccFooterSignupForm';

      var btn = footerForm.querySelector('.cc-footer__signup-btn');
      if (btn) {
        btn.disabled = true;
        btn.textContent = '...';
      }
      // Native submit continues so Shopify hCaptcha can attach a token.
    });

    var footerBtn = footerForm.querySelector('.cc-footer__signup-btn');
    if (footerBtn) footerBtn.dataset.label = footerBtn.textContent;
  }

})();
